import { useEffect, useRef, useState } from "react";
import { Dots } from "./Dots";

export const FullPageScroll = ({
	children,
	onLoad = () => {},
	onPageChange = () => {},
}) => {
	const outerDivRef = useRef(null);
	const currentPage = useRef(0);
	const canScroll = useRef(true);
	const oldTouchY = useRef(0);
	const [_, refresh] = useState(0);

	const scrollDown = () => {
		const pageHeight = outerDivRef.current?.children.item(0)?.clientHeight; // 화면 세로 길이 100vh
		if (outerDivRef.current && pageHeight) {
			outerDivRef.current.scrollTo({
				top: pageHeight * (currentPage.current + 1),
				left: 0,
				behavior: "smooth",
			});
			canScroll.current = false;
			setTimeout(() => {
				canScroll.current = true;
			}, 1000); //스크롤 막기 타이머
			if (outerDivRef.current.childElementCount - 1 > currentPage.current)
				currentPage.current++;
		}
		onPageChange(currentPage.current);
		refresh((v) => v + 1);
    updateActiveSection();
	};

	const scrollMove = () => {
		const pageHeight = outerDivRef.current?.children.item(0)?.clientHeight; // 화면 세로 길이 100vh
		if (outerDivRef.current && pageHeight) {
			outerDivRef.current.scrollTo({
				top: pageHeight * (currentPage.current + 1),
				left: 0,
				behavior: "auto",
			});
			canScroll.current = false;
			setTimeout(() => {
				canScroll.current = true;
			}, 100); //스크롤 막기 타이머
			if (outerDivRef.current.childElementCount - 1 > currentPage.current)
				currentPage.current++;
		}
		onPageChange(currentPage.current);
		refresh((v) => v + 1);
    updateActiveSection();
	};

	const scrollUp = () => {
		const pageHeight = outerDivRef.current?.children.item(0)?.clientHeight; // 화면 세로 길이 100vh
		if (outerDivRef.current && pageHeight) {
			outerDivRef.current.scrollTo({
				top: pageHeight * (currentPage.current - 1),
				left: 0,
				behavior: "smooth",
			});
			canScroll.current = false;
			setTimeout(() => {
				canScroll.current = true;
			}, 1000); //스크롤 막기 타이머
			if (currentPage.current > 0) currentPage.current--;
		}
		onPageChange(currentPage.current);
		refresh((v) => v + 1);
    updateActiveSection();
	};

  const updateActiveSection = () => {
    const sections = outerDivRef.current.children;
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      if (i === currentPage.current) {
        section.classList.add("active"); // 활성화된 섹션에 'active' 클래스 추가
      } else {
        // section.classList.remove("active"); // 비활성화된 섹션에서 'active' 클래스 제거
      }
    }
  };

	const wheelHandler = (e) => {
		e.preventDefault();
		if (!canScroll.current) return;
		const { deltaY } = e; // +is down -is up
		// console.log("scroll to", outerDivRef.current?.scrollHeight);
		if (deltaY > 0 && outerDivRef.current) {
			scrollDown();
		} else if (deltaY < 0 && outerDivRef.current) {
			scrollUp();
		}
	}; // wheel Handler

	const scrollHandler = (e) => {
		e.preventDefault();
	};

	const onTouchDown = (e) => {
		oldTouchY.current = e.changedTouches.item(0)?.clientY || 0;
	};

	const onTouchUp = (e) => {
    if (e.target.tagName !== "BUTTON" && e.target.tagName !== "A") { // 버튼 클릭 시 터치 이벤트 무시
      const currentTouchY = e.changedTouches.item(0)?.clientY || 0;
      const isScrollDown = oldTouchY.current - currentTouchY > 0 ? true : false;

      if (isScrollDown) {
        scrollDown();
      } else {
        scrollUp();
      }
    }
	};

  const keydownHandler = (e) => {
    if (!canScroll.current) return;
    if (e.key === "ArrowUp") {
        scrollUp();
    } else if (e.key === "ArrowDown") {
        scrollDown();
    }
  };

	useEffect(() => {
		const outer = outerDivRef.current;
		if (!outer) return;
		onLoad(outerDivRef.current.childElementCount);
		refresh((v) => v + 1);
		outer.addEventListener("wheel", wheelHandler);
		outer.addEventListener("scroll", scrollHandler);
		outer.addEventListener("touchmove", scrollHandler);
		outer.addEventListener("touchstart", onTouchDown);
		outer.addEventListener("touchend", onTouchUp);
    window.addEventListener("keydown", keydownHandler); // 키보드 이벤트 추가

		// onLoad 이벤트에서 localStorage에서 moveSectionNum 값을 가져와 해당 섹션으로 이동
    const moveSectionNum = localStorage.getItem('moveSectionNum');
    if (moveSectionNum) {
      currentPage.current = parseInt(moveSectionNum);
			scrollMove(); // 해당 섹션으로 이동
			localStorage.removeItem('moveSectionNum'); // 페이지 localStorage 제거
    }
		
    // updateActiveSection();
		return () => {
			outer.removeEventListener("wheel", wheelHandler);
			outer.removeEventListener("scroll", scrollHandler);
			outer.removeEventListener("touchmove", scrollHandler);
			outer.removeEventListener("touchstart", onTouchDown);
			outer.removeEventListener("touchend", onTouchUp);
      window.removeEventListener("keydown", keydownHandler); // 이벤트 리스너 삭제
		};
	}, []);
	const movePageTo = (index) => {
		const num = currentPage.current;
		if (index > num) for (let i = 0; i < index - num; i++) scrollDown();
		else if (index < num) for (let i = 0; i < num - index; i++) scrollUp();
	};


	return (
		<>
			<div
        className="intro-wrap ready"
				ref={outerDivRef}
				style={{ height: "calc(var(--vh, 1vh) * 100)", width: "100%", overflowY: "hidden" }}
			>
				{children}
			</div>
			<Dots
				limit={outerDivRef.current?.childElementCount || 0}
				currentIndex={currentPage.current}
				onDotClick={movePageTo}
			/>

		</>
	);
};

export default FullPageScroll;